import React from 'react'
import Form from 'react-bootstrap/Form'
import { ATCheckboxProps } from './FormComponentProps'

const ATCheckBox: React.FC<ATCheckboxProps> = ({
  label,
  handleChange,
  disabled,
  selectedValue,
  checked = false,
  className = '',
}) => {
  return (
    <Form.Check
      type="checkbox"
      label={label}
      aria-label={label}
      disabled={disabled}
      onChange={handleChange}
      value={selectedValue.toString()}
      checked={checked}
      className={className}
    ></Form.Check>
  )
}
export default ATCheckBox
